module.exports = __webpack_public_path__ + "fonts/Comfortaa-Medium.1c593a56.ttf";